/**
 * Featured collection new: collection tabs + Swiper refresh when switching tabs.
 * Carousels use <featured-collection-swiper> (extends theme Swiper web component).
 */
(function () {
  if (window.__featuredCollectionNewJsBound) return;
  window.__featuredCollectionNewJsBound = true;

  function refreshSwipersIn(root) {
    root.querySelectorAll('featured-collection-swiper').forEach(function (el) {
      if (typeof el.refresh === 'function') el.refresh();
    });
  }

  function refreshVisiblePanelSwipers(root) {
    var panel = root.querySelector('.fc-wrapper:not(.d-none)');
    if (!panel) return;
    panel.querySelectorAll('featured-collection-swiper').forEach(function (el) {
      if (typeof el.refresh === 'function') el.refresh();
    });
  }

  function onTabClick(root, e) {
    var btn = e.target.closest('.featured-collection-new__tabs [data-tab-collection]');
    if (!btn || !root.contains(btn)) return;
    e.preventDefault();

    var id = btn.getAttribute('data-tab-collection');
    if (!id) return;

    root.querySelectorAll('.featured-collection-new__tabs [data-tab-collection]').forEach(function (b) {
      var li = b.closest('li');
      var on = b.getAttribute('data-tab-collection') === id;
      if (li) li.classList.toggle('active', on);
      b.setAttribute('aria-selected', on ? 'true' : 'false');
    });

    root.querySelectorAll('.fc-wrapper').forEach(function (w) {
      w.classList.toggle('d-none', w.getAttribute('data-tab-collection') !== id);
    });

    requestAnimationFrame(function () {
      refreshVisiblePanelSwipers(root);
    });
    setTimeout(function () {
      refreshVisiblePanelSwipers(root);
    }, 50);
    setTimeout(function () {
      refreshVisiblePanelSwipers(root);
    }, 300);
  }

  function bindRoot(root) {
    if (!root || root.getAttribute('data-fcn-tabs-bound') === 'true') return;
    root.setAttribute('data-fcn-tabs-bound', 'true');
    root.addEventListener('click', function (e) {
      onTabClick(root, e);
    });
  }

  function initAllInDocument() {
    document.querySelectorAll('.featured-collection-new-root').forEach(function (root) {
      bindRoot(root);
      refreshVisiblePanelSwipers(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllInDocument);
  } else {
    initAllInDocument();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root =
      event.target && event.target.querySelector
        ? event.target.querySelector('.featured-collection-new-root')
        : null;
    if (root) {
      bindRoot(root);
      requestAnimationFrame(function () {
        refreshSwipersIn(root);
      });
    }
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root =
      event.target && event.target.querySelector
        ? event.target.querySelector('.featured-collection-new-root')
        : null;
    if (root) root.removeAttribute('data-fcn-tabs-bound');
  });
})();
